import { render, staticRenderFns } from "./comparison-modal.vue?vue&type=template&id=691e1bcc&scoped=true&lang=pug&"
import script from "./comparison-modal.vue?vue&type=script&lang=coffee&"
export * from "./comparison-modal.vue?vue&type=script&lang=coffee&"
import style0 from "./comparison-modal.vue?vue&type=style&index=0&id=691e1bcc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691e1bcc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CraftVisual: require('/opt/build/repo/node_modules/@bkwld/cloak/components/craft-visual.coffee').default})
